import { combineReducers } from '@reduxjs/toolkit';

import settingsDialogReducer from './settingsDialogReducer';
import themeReducer from './themeReducer';

/**
 * Combined reducer for the core domain
 *
 * Note: User preferences are managed via React Context (UserPreferencesProvider)
 * per project architecture standards - see _agent/rules/domain/state-management.md
 */
const coreReducer = combineReducers({
  settingsDialog: settingsDialogReducer,
  theme: themeReducer,
});

export default coreReducer;
